import { mapActions } from 'vuex';

export default {
	data() {
		return {
			rejecteds: [],
			headerData: [],
			products: [],
			productData: [],
			needActivityState: false,
			selectTreeData: [],
			selectKeysData: [],
			addFieldData: [],
			productVisible: false,
			mode: 0,
		}
	},

	methods: {
		...mapActions([
			'reqActivitySetting',
			'reqActivityDecalareTemplateDetail',
			'reqActivityDecalareTemplateList',
			'reqActivityShopProduct',
			'reqShopInfo'
		]),
		async getProductInfo() {
			let platform;
			let shopid;
			const res = await this.reqShopInfo();
			platform = res.data.platformCode;
			shopid = res.data.id;
			this.productData = await this.reqActivityShopProduct({
				platform,
				shopid
			});
		},
		// 添加或删除一行
		onAddOrDeleteRow(data) {
			if(data.flag) {
				const product = { product: {}, product_url: '' }

				this.mode === 1 && delete product.product;
				this.products.push( product );
				console.log(_.cloneDeep(this.products));

			}else {
				this.products.splice(data.index, 1);
			}
		},
		// 后端字段不统一，强制修改参数 驼峰的改成下划线
		handleTemplateData(templates) {
			console.log(templates)
			let res = [];
			if(templates.length) {
				for(let template of templates) {
					console.log(template);
					// 转换字段，后端字段不统一，卒
					let obj = {};
					obj['actual_price'] = template['actualPrice'] ? template['actualPrice'] : undefined;
					obj['apply_price'] = template['applyPrice'] ? template['applyPrice'] : undefined;
					obj['sales'] = template['sales'];
					obj['estimated_sales'] = template['estimatedSales'] ? template['estimatedSales'] : undefined;
					obj['product_id'] = template['productInfo'];
					obj['product_url'] = template['productUrl'];
					obj['productInfo'] = template['classifyname']
					obj['breakdo_wnminimum'] = template['breakdownminimum'];
					obj['add_field'] = template.addField;
					obj['breakField'] = JSON.parse(template['breakdownminimum'])
					const addField = JSON.parse(template.addField);
					for(const i in addField) {
						obj[i] = addField[i];
					}
					res.push(obj);
				}
			}

			return res;
		},
		// 后端字段不统一，强制修改参数 下划线的改成驼峰  卒
		changeCtlistData(ctlist) {
			for(const item of ctlist) {
				item.product_url && (item.productUrl = item.product_url);
				item.apply_price && (item.applyPrice = item.apply_price);
				item.actual_price && (item.actualPrice = item.actual_price);
				item.estimated_sales && (item.estimatedSales = item.estimated_sales);
				item.productInfo && (item.classifyname = item.productInfo);
				item.product_id && (item.productInfo = item.product_id);
				item.breakdo_wnminimum && (item.breakdownminimum = item.breakdo_wnminimum);
			}
			return ctlist;
		},
		// 保存模板
		async onSaveTemplate(id) {
			const vaildTable = this.$refs['activityTable'].validTable();
			if(!vaildTable) {
				return;
			}
			const ctlist = this.$refs['activityTable'].getTableData(false);
			const finalCtlist = this.changeCtlistData(ctlist);
			if(this.isInTemplate) {
				const vaildForm = await this.$refs['activityForm'].validForm();
				if(!vaildForm) {
					return;
				}
			}
			if(!finalCtlist.length) {
				this.$message.error('请添加模板数据')
				return;
			}
			const data = {
				templatename: this.isInTemplate ? this.ruleForm.templatename : this.templateForm.templatename,
				ctlist: finalCtlist,
				declaremeans: String(this.mode)
			}
			id !== 'add' && (data.id = id);

			const { status, message } = await fetch({
				url: 'hcm/campgign/savaCampaigntemplate',
				method: 'post',
				data: JSON.stringify(data),
				headers: {
					'Content-Type': 'application/json'
				}
			})

			if(status === '400') {
				this.$message.error(message)
			}
			if(status === '10000') {
				this.$message.success('保存模板成功!');
				if(!this.isInTemplate) {
					this.reqActivityDecalareTemplateList({
						pageNo: 1,
						pageSize: 10000
					})
					this.templateVisible = false;
				}else {
					this.$router.push('/Brand/floatingPlaten/main')
				}
			}
		},
		// 编辑时删除产品
		onDeleteProduct(data) {
			this.rejecteds.push(data.row.hid)
			this.products.splice(data.$index, 1);
			this.selectTreeData.splice(data.$index, 1);
			this.selectKeysData.splice(data.$index, 1);
			this.addFieldData.splice(data.$index, 1);

			this.$nextTick(() => {
				this.$refs.productDialog.refleshChecked({
					key: this.selectKeysData,
					tree: this.selectTreeData,
					addFieldData: this.addFieldData,
				});
			})
		},
		// 添加活动模板数据
		onAddTemplateData(templates) {
			for(const template of templates) {
				const id = `${template.product_id},${template.productInfo}`
				this.products.push(template);
				if(!this.selectKeysData.includes(id)) {
					this.selectKeysData.push(id)
					this.selectTreeData.push({
						product_id: template.product_id,
						productInfo: template.productInfo,
						productLink: template.productLink
					})
					this.$nextTick(() => {
						this.$refs.productDialog.refleshChecked({
							key: this.selectKeysData,
							tree: this.selectTreeData,
							addFieldData: this.addFieldData,
						});
					})
				}
			}
		},
		// 添加产品，跳弹窗
		onAddProduct() {
			this.productVisible = true;
		},
		// 申报方式改动回调
		onWayChange(val) {
			this.mode = val;
			this.initProductData(val);
			this.products = [];
		},
		// 产品选完后过滤掉部分数据
		filterProductData() {
			const productIdList = this.products.reduce((res, cur) => {
				res.push(cur.product_id);
				return res;
			}, []);
			const selectIdList = this.selectTreeData.reduce((res, cur) => {
				res.push(cur.product_id);
				return res;
			}, [])
			this.selectTreeData.forEach(item => {
				if(!productIdList.includes(item.product_id)) {
					this.products.push({
						product_id: item.product_id,
						productInfo: item.productInfo,
						product_url: '',
						productLink: item.productLink,
						breakField: {}
					})
				}
			})
			for (let a in this.addFieldData) {
				for (let b in this.products) {
					if (this.addFieldData[a]) {
						this.products[b].breakField = this.addFieldData[a]
					} else {
						this.products[b].breakField = {}
					}
				}
			}

			this.products.forEach((item, index) => {
				if(!selectIdList.includes(item.product_id)) {
					this.products.splice(index, 1);
				}
			})
			console.log(this.products);

		},
		// 关闭产品选择弹窗
		onCloseProductDialog(val) {
			console.log(val)
			if(val) {
				this.selectTreeData = val.tree;
				this.selectKeysData = val.key;
				this.addFieldData = val.addFieldData;
			}
			this.productVisible = false;
			this.filterProductData();
			console.log(this.selectTreeData);
			console.log(this.addFieldData);
		},
		// 给字段排序
		getAndSortSetting(setting) {
			let res = [];
			for(const i in setting) {
				const data = setting[i].data;
				for(let item of data) {
					if(setting[i].title === '价格字段') {
						item.isPriceField = true;
					}
					if(item.isChecked === 1) {
						if(item.sort === null) {
							item.sort = 999999999999;
						}
						res.push(item);
					}
				}
			}

			res.sort((a, b) => (a.sort - b.sort));
			console.log(res);
			return res;
		},
		// 初始化表格头部字段
		initTableHeaderTitle(setting, way) {
			const sortedFields = this.getAndSortSetting(setting);
			let res = [];

			sortedFields.forEach(item => {
				let obj = {
					name: item.fieldname,
					key: item.fieldvalue,
					mode: way
				}
				if(item.fieldname === '产品型号' || item.fieldname === '活动链接') {
					obj.width = '400';
				}else {
					obj.width = '200';
				}
				if(item.isPriceField) {
					obj.isPriceField = true;
				}else {
					obj.isPriceField = false;
				}
				obj.required = true;
				res.push(obj);
			})
			this.headerData = [];
			// 使用宏任务是解决切换模式时数据还保留上次的问题
			setTimeout(() => {
				this.headerData = res;
				console.log(this.headerData);
			}, 0);
		},
		// 初始化表格数据
		initProductData(way) {
			const params = {
				module: way === 0 ? 'CAMPAIGN' : way === 1 ? 'CAMPAIGNLINK' : 'CAMPAIGNSHOP'
			}
			this.reqActivitySetting(params).then(res => {
				this.initTableHeaderTitle(res, way);
			})
		},
		// 回显表格数据
		echoTableData(list, campaignway, needActivityState) {
			this.needActivityState = needActivityState;
			this.initProductData(campaignway);
			console.log(list)
			list.forEach(item => {
				// 我的模板页面里要修改product_info，后端字段不统一
				if(!this.isInTemplate) {
					item.productInfo = item.product_info;
				}
				item.actual_price === 0 && (item.actual_price = '');
				item.apply_price === 0 && (item.apply_price = '');
				item.estimated_sales === 0 && (item.estimated_sales = '');
				item.breakField = {};
				this.products.push(item);
			})
			console.log(this.products);
		},
	}
}
